import React, { forwardRef, useImperativeHandle } from 'react'
import { Step2RegisterInfoWrapper } from './Step2RegisterInfoStyled'
import {
  AccountInfoLabel, AccountInfoValue,
  AccountInfoWrapper,
  BackArrowWrapper,
  Container,
  FormBigTitle,
  FormLabel, FormLabelWrapper, FormRequired,
  FormWrapper,
  TopLeft,
} from '../CommonStyled/CommonStyled'
import IMAGES from '../../images'
import { Button, Col, Form, Input, Row, Select } from 'antd'
import PropTypes from 'prop-types'
import { BREAKPOINT, SELECT_DOCUMENT_TYPE_LIST } from '../../constant'
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import { breakPointState } from '../../recoil/commonState'
import AccountInfo from '../AccountInfo'
import stringUtils from '../../utils/stringUtils'
import numberUtils from '../../utils/numberUtils'
import validator from '../../validator'
import accountStore from '../../stores/accountStore'
import { checkAccountState } from '../../recoil/accountStateState'

const Step2RegisterInfo = forwardRef((props, ref) => {
  const { onClickBack, nextStep, accountInfo, onCancel } = props
  const breakPoint = useRecoilValue(breakPointState)
  const setCheckAccount = useSetRecoilState(checkAccountState)
  const resetCheckAccount = useResetRecoilState(checkAccountState)

  const [form] = Form.useForm()
  const handleSubmit = (values) => {
    // Chỗ này tùy get info về xem đã hold chưa
    // Đã hold: sang step 3A
    // Chưa hold: sang step 3B
    let payload = {
      legalId: values?.legalId,
      status: 'ON_HOLD',
    }
    accountStore.checkLegalId(payload)
      .then(res => {
        let isHold = (res?.statusCode == 200 && res?.data?.length > 0)
        if (res?.data?.length > 0) {
          setCheckAccount(res?.data)
        }
        const response = { id: 1, hold: isHold, ...values }
        nextStep && nextStep(response)
      })
      .catch(error => {
        if (error?.response?.data?.statusCode == '401') {
          onCancel && onCancel()
        }
      })
  }
  const handleClickBack = () => {
    onClickBack()
  }

  const resetForm = () => {
    form.resetFields()
    resetCheckAccount()
  }

  useImperativeHandle(ref, () => ({
    resetForm,
  }))

  return (
    <Step2RegisterInfoWrapper>
      <Container>
        <FormWrapper>
          <BackArrowWrapper>
            <img src={IMAGES.BACK_ARROW} alt={'back'} onClick={handleClickBack} />
          </BackArrowWrapper>
          <Row justify={'center'}>
            <Col xs={24} sm={24} md={24} lg={22} xl={22} xxl={20}>
              <AccountInfo accountNumber={accountInfo?.accountNumber} fee={accountInfo?.reducedFee} />
              <FormBigTitle
                margin={'48px 0 40px 0'}
                textAlign={'center'}>
                Thông tin Quý khách hàng
              </FormBigTitle>
              <Form
                form={form}
                layout={'vertical'}
                onFinish={handleSubmit}
              >
                <Row
                  gutter={[
                    { xs: 0, sm: 0, md: 16, lg: 16, xl: 16, xxl: 16 },
                    { xs: 0, sm: 0, md: 16, lg: 16, xl: 16, xxl: 16 },
                  ]}
                  justify={{
                    xs: 'center',
                    sm: 'center',
                    md: 'center',
                    lg: 'center',
                    xl: 'center',
                    xxl: 'center',
                  }}
                  align={'bottom'}
                >
                  {/*<Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>*/}
                  {/*  <Form.Item*/}
                  {/*    label={<>*/}
                  {/*      <FormLabel>Loại giấy tờ</FormLabel>*/}
                  {/*      <FormRequired> * </FormRequired>*/}
                  {/*    </>}*/}
                  {/*    rules={[{ validator: validator.validateDocumentType }]}*/}
                  {/*    name={'documentType'}*/}
                  {/*  >*/}
                  {/*    <Select*/}
                  {/*      placeholder={'Chọn'}*/}
                  {/*      style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}>*/}
                  {/*      {*/}
                  {/*        SELECT_DOCUMENT_TYPE_LIST.map((item, index) =>*/}
                  {/*          <Select.Option key={index} value={item.value}>{item.label}</Select.Option>,*/}
                  {/*        )*/}
                  {/*      }*/}
                  {/*    </Select>*/}
                  {/*  </Form.Item>*/}
                  {/*</Col>*/}
                  <Col xs={24} sm={24} md={16} lg={16} xl={16} xxl={16}>
                    <Form.Item
                      label={<>
                        <FormLabel>Số ĐKKD/QĐTL</FormLabel>
                        <FormRequired> * </FormRequired>
                      </>}
                      rules={[{ validator: validator.validateDocumentNumber }]}
                      name={'legalId'}
                    >
                      <Input
                        maxLength={35}
                        style={{ height: (breakPoint === BREAKPOINT.XS || breakPoint === BREAKPOINT.SM) ? 'auto' : 48 }}
                        autoComplete={'off'} placeholder={'Nhập nội dung'} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24} style={{ textAlign: 'right' }}>
                    <Button style={{ minWidth: 120 }} type={'primary'} htmlType={'submit'}>Tra cứu</Button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </FormWrapper>
      </Container>
    </Step2RegisterInfoWrapper>
  )
})

Step2RegisterInfo.propTypes = {
  onClickBack: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  accountInfo: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
}

export default Step2RegisterInfo
